export const en = {
  'app.name': 'DaYi Compass',
  'app.tagline': 'Ancient wisdom for modern choices',
  'app.disclaimer': 'For cultural study and personal reflection only. Not a substitute for professional, medical, or legal advice.',
  'nav.today': 'Today',
  'nav.bazi': 'BaZi',
  'nav.cast': 'Ask',
  'nav.profiles': 'Profiles',
  'nav.settings': 'Settings',

  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.switch': 'Switch',
  'common.active': 'Active',
  'common.name': 'Name',
  'common.gender': 'Gender',
  'common.male': 'Male',
  'common.female': 'Female',
  'common.unknown': 'Unknown',
  'common.loading': 'Loading…',

  'auth.login': 'Sign in',
  'auth.register': 'Sign up',
  'auth.email': 'Email',
  'auth.password': 'Password (min 8 characters)',
  'auth.nickname': 'Nickname (optional)',
  'auth.nicknamePlaceholder': 'What should we call you',
  'auth.loginBtn': 'Sign in',
  'auth.registerBtn': 'Create account',
  'auth.dataNote': 'Your profiles and readings are stored in your account and synced across devices. Signing out removes local copies from this device.',
  'auth.error.invalidEmail': 'Please enter a valid email address',
  'auth.error.passwordWeak': 'Password must be at least 8 characters',
  'auth.error.emailExists': 'This email is already registered — please sign in',
  'auth.error.wrong': 'Wrong email or password',
  'auth.error.rateLimited': 'Too many attempts, please try again shortly',
  'auth.error.network': 'Cannot reach the server. Check your connection and try again.',
  'auth.error.generic': 'Something went wrong. Please try again.',
  'account.title': 'Account',
  'account.email': 'Email',
  'account.nickname': 'Nickname',
  'account.logout': 'Sign out',
  'account.logoutConfirm': 'Sign out? Local copies of your profiles and readings will be cleared from this device. Cloud data stays intact.',
  'account.localData': 'This device has {n} profile(s) not yet synced to your account. You can import them (nothing uploads automatically — accounts stay isolated).',
  'account.import': 'Import to account',
  'account.imported': 'Imported ✓',
  'account.importFailed': 'Import failed. Please try again.',

  'today.title': 'Today\'s Guidance',
  'today.subtitle': 'Personalized by your BaZi and the day\'s Ganzhi',
  'today.lunar': 'Lunar',
  'today.solar': 'Solar',
  'today.ganzhi': 'Day Ganzhi',
  'today.yi': 'Do',
  'today.ji': 'Avoid',
  'today.pengzu': 'PengZu Taboos',
  'today.jishen': 'Auspicious Gods',
  'today.xiongsha': 'Inauspicious',
  'today.shen': 'ZhiShen',
  'today.chong': 'Clash',
  'today.sha': 'Sha Direction',
  'today.positions': 'Auspicious Directions',
  'today.dayLuck': 'Your day luck',
  'today.dayLuck.good': 'Flourishing',
  'today.dayLuck.mid': 'Steady',
  'today.dayLuck.bad': 'Stay grounded',
  'today.fiveElements': 'Five Elements',
  'today.advice': 'Advice for you',
  'today.qiMen': 'Qimen today',
  'today.switchProfile': 'Switch profile',
  'today.noProfile': 'No BaZi profile yet. Add one to get personalized daily guidance.',
  'today.addProfile': 'Add profile',
  'today.energy.high': 'Good window for focus and energy',
  'today.energy.low': 'Pace yourself today and conserve energy',
  'today.energy.mid': 'Steady day, best for routine work',
  'today.focusYear': 'Year luck',
  'today.focusGanzhi': 'Annual Ganzhi',
  'today.focusDaYun': 'Major cycle',
  'today.focusLevel.good': 'Supportive',
  'today.focusLevel.mid': 'Steady',
  'today.focusLevel.bad': 'Constrained',
  'today.focusGenderHint': 'Gender unknown — the major cycle direction is approximate.',

  'bazi.title': 'Four Pillars (BaZi)',
  'bazi.subtitle': 'Chart cast with true solar time',
  'bazi.pillars': 'Pillars',
  'bazi.year': 'Year',
  'bazi.month': 'Month',
  'bazi.day': 'Day',
  'bazi.hour': 'Hour',
  'bazi.dayMaster': 'Day Master',
  'bazi.hiddenStems': 'Hidden Stems',
  'bazi.tenGods': 'Ten Gods',
  'bazi.nayin': 'NaYin',
  'bazi.stems': 'Heavenly Stems',
  'bazi.branches': 'Earthly Branches',
  'bazi.wuxing': 'Five Elements',
  'bazi.strength': 'Day Master Strength',
  'bazi.usefulGod': 'Favorable Element',
  'bazi.avoidGod': 'Avoid Element',
  'bazi.daYun': 'Major Cycles',
  'bazi.liuNian': 'Year Luck',
  'bazi.birthInfo': 'Birth Info',
  'bazi.solarTime': 'True Solar Time',
  'bazi.standardTime': 'Local Time',
  'bazi.daYun.startAge': 'Starts at',
  'bazi.god.wealth': 'Direct Wealth',
  'bazi.god.officer': 'Direct Officer',
  'bazi.god.seal': 'Direct Seal',
  'bazi.god.rob': 'Friend',
  'bazi.god.eat': 'Eating God',
  'bazi.god.kill': 'Seven Killings',
  'bazi.god.hurt': 'Hurting Officer',
  'bazi.god.wealth2': 'Indirect Wealth',
  'bazi.god.officer2': 'Seven Killings',
  'bazi.god.seal2': 'Indirect Seal',

  'cast.title': 'Ask the Moment',
  'cast.subtitle': 'Plum Blossom Numerology · one question, one cast',
  'cast.method': 'Casting method',
  'cast.method.numbers': 'Numbers from your mind',
  'cast.method.time': 'Current time',
  'cast.method.words': 'Chinese characters',
  'cast.askPlaceholder': 'What are you hesitating about? (optional — helps tailor the reading)',
  'cast.numberHint': 'Hold your question in mind, then give three numbers (or glance at a clock for three digits)',
  'cast.wordsHint': 'Write 2–6 characters related to your question',
  'cast.btn': 'Cast',
  'cast.result.title': 'Hexagram Reading',
  'cast.primary': 'Primary',
  'cast.mutual': 'Mutual',
  'cast.changed': 'Changed',
  'cast.body': 'Body',
  'cast.use': 'Use',
  'cast.bodyUse': 'Body–Use relation',
  'cast.qi': 'Hexagram Qi',
  'cast.month': 'Casting month',
  'cast.verdict': 'Overall verdict',
  'cast.yings': 'Timing hint',
  'cast.yaoText': 'Moving line',
  'cast.retry': 'Cast again',
  'cast.adviceTitle': 'Narrative advice',
  'cast.bodyUse.sheng': 'Use nourishes Body: support',
  'cast.bodyUse.ke': 'Use overcomes Body: constraint',
  'cast.bodyUse.bihe': 'Body and Use in harmony: smooth',
  'cast.bodyUse.shengBody': 'Body nourishes Use: giving',
  'cast.bodyUse.keBody': 'Body overcomes Use: in control',
  'cast.qi.monthShengBody': 'The month nourishes Body — timing favors you',
  'cast.qi.monthKeBody': 'The month overcomes Body — prefer stillness',
  'cast.qi.bihe': 'The month is in harmony with Body',
  'cast.qi.bodyShengMonth': 'Body nourishes the month — conserve and build',
  'cast.qi.bodyKeMonth': 'Body overcomes the month — you may act',

  'qimen.title': 'Qimen Dunjia',
  'qimen.subtitle': 'Hour Qimen · timing and direction',
  'qimen.ju': 'Board',
  'qimen.yuan': 'Yuan',
  'qimen.dun': 'Dun',
  'qimen.plate': 'Nine-Palace Plate',
  'qimen.palace': 'Palace',
  'qimen.stars': 'Nine Stars',
  'qimen.doors': 'Eight Doors',
  'qimen.gods': 'Eight Gods',
  'qimen.skyPan': 'Heaven plate',
  'qimen.earthPan': 'Earth plate',
  'qimen.gan': 'QiYi',
  'qimen.goodDoor': 'Auspicious doors',
  'qimen.goodStar': 'Auspicious stars',
  'qimen.wonder': 'Three Wonders',
  'qimen.verdict': 'Timing advice',
  'qimen.person': 'Day stem palace',
  'qimen.time': 'Hour stem palace',
  'qimen.mode.switch': 'Switch to Qimen Dunjia',
  'qimen.mode.meihua': 'Switch to Plum Blossom',
  'qimen.now': 'Cast for the current moment',
  'today.qimenReading': 'Qimen interpretation',
  'cast.qimenReading': 'Qimen interpretation',

  'profile.title': 'BaZi Profiles',
  'profile.subtitle': 'Save multiple birth charts and switch anytime',
  'profile.nickname': 'Nickname (e.g. Me / Mom)',
  'profile.birthDate': 'Birth date',
  'profile.birthTime': 'Birth time',
  'profile.birthCity': 'Birth city (for true solar time)',
  'profile.cityPlaceholder': 'e.g. Beijing / Shanghai (optional)',
  'profile.unknownTime': 'Time unknown',
  'profile.add': 'New profile',
  'profile.edit': 'Edit profile',
  'profile.deleteConfirm': 'Delete this profile?',
  'profile.empty': 'No profiles yet. Add your birth info below.',
  'profile.required': 'Please enter a nickname and birth date',
  'profile.focusYear': 'Year luck (optional)',
  'profile.focusYearNone': 'Not set (follow the present)',
  'profile.focusYearHint': 'Pick a year and daily guidance will also weigh that year\'s annual stem-branch and major cycle.',

  'settings.ai': 'Reading Service',
  'settings.ai.builtin': 'Built-in DeepSeek service',
  'settings.ai.builtinDesc': 'Provided by the site operator via a server-side proxy — ready to use, no key needed.',
  'settings.ai.custom': 'Custom service',
  'settings.ai.customDesc': 'Using a custom compatible service (key stored on this device only).',
  'settings.ai.advanced': 'Advanced: custom service',
  'settings.ai.hideAdvanced': 'Hide advanced settings',
  'settings.ai.advancedHint': 'To use your own provider or proxy, configure it here. Clearing the key restores the built-in service.',
  'settings.ai.baseUrl': 'Base URL',
  'settings.ai.model': 'Model',
  'settings.ai.apiKey': 'API Key (blank = built-in service)',
  'settings.ai.apiKeyPlaceholder': 'Leave blank to use the built-in service',
  'settings.ai.useBuiltin': 'Restore built-in service',
  'settings.ai.save': 'Save config',
  'settings.ai.test': 'Test connection',
  'settings.ai.testing': 'Testing…',
  'settings.ai.testOk': 'Connection OK ✓',
  'settings.ai.testFail': 'Connection failed',
  'settings.ai.saved': 'Config saved',
  'settings.ai.privacy': 'Built-in mode: requests go through the site proxy and the key stays with the site. Custom mode: the key stays in this browser and requests go directly to the endpoint you configure.',

  'bazi.reading': 'Chart Reading',
  'bazi.reading.subtitle': 'Generated once · archived forever · regenerate after deleting',
  'bazi.reading.empty': 'No detailed reading yet for this profile. Once generated it is archived, shown every time you open this page, and never generated again automatically.',
  'bazi.reading.generate': 'Generate detailed reading',
  'bazi.reading.generating': 'Generating… (about 30–60 s; keep this page open)',
  'bazi.reading.noKey': 'No reading service configured yet — add your API key in Settings first.',
  'bazi.reading.error': 'Generation failed',
  'bazi.reading.createdAt': 'Generated at',
  'bazi.reading.delete': 'Delete reading',
  'bazi.reading.deleteConfirm': 'You can regenerate it later. Delete this archived reading?',
  'bazi.reading.advice': 'Action suggestions',
  'bazi.reading.sectionTitle': 'Reading',
  'settings.title': 'Settings',
  'settings.language': 'Language / 语言',
  'settings.theme': 'Theme',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Light',
  'settings.theme.dark': 'Dark',
  'settings.about': 'About',
  'settings.version': 'Version',
  'settings.dataLocal': 'All data stays in your browser on this device.',
  'settings.ethics': 'Divination is an ancient lens for reflection, not fate. Read wisely.',

  'wuxing.metal': 'Metal',
  'wuxing.wood': 'Wood',
  'wuxing.water': 'Water',
  'wuxing.fire': 'Fire',
  'wuxing.earth': 'Earth',
  'direction.north': 'N',
  'direction.south': 'S',
  'direction.east': 'E',
  'direction.west': 'W',
  'direction.ne': 'NE',
  'direction.nw': 'NW',
  'direction.se': 'SE',
  'direction.sw': 'SW',
  'direction.center': 'C',
} as const;

